import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingLeft: '4%',
    paddingRight: '4%'
  },
  pageTitle: {
    color: theme.palette.primary.main,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(1),
  },
  card: {
    width: 400,
    [theme.breakpoints.down('md')]: {
      width: 300
    },
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column'
  },
  cardBody: {
    flex: 1,
    padding: theme.spacing(1.5, 2, 1)
  },
  cardTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  orgName: {
    fontWeight: 600,
    fontSize: '0.9rem',
    lineHeight: 1.3,
    wordBreak: 'break-word',
    paddingTop: theme.spacing(1.5)
  },
  addOwnerButton: {
    fontSize: '0.75rem',
    padding: theme.spacing(0.25, 0.5),
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  orgAvatar: {
    width: 36,
    height: 36,
    fontSize: '0.875rem',
    flexShrink: 0
  },
  createdDate: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    paddingTop: theme.spacing(0.75)
  },
  cardFooter: {
    padding: theme.spacing(0.5, 1.5, 1.5),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  addOrgCard: {
    width: 400,
    [theme.breakpoints.down('md')]: {
      width: 300
    },
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: `2px dashed ${theme.palette.primary.light}`,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  addOrgIcon: {
    fontSize: 48,
    color: theme.palette.primary.light
  },
  addOrgLabel: {
    color: theme.palette.primary.light,
    fontSize: '0.9rem'
  },
  seeMoreButton: {
    fontSize: '0.8rem',
    padding: theme.spacing(0.25, 0.5),
  }
}));
